import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import Image from "next/image"
import Link from "next/link"
import { useMemo } from "react"

const Card = (cardData: any) => {
  const { title, featuredImage, summary, slug, kicker } = cardData
  const { width, height, url } = featuredImage

  const summaryText = useMemo(() => {
    if (summary) {
      return documentToReactComponents(summary.json)
    }
  }, [summary])

  if (!featuredImage || !title) {
    return <></>
  }

  const altText = title ? `${title} – The Richard Pousette-Dart Foundation` : `The Richard Pousette-Dart Foundation`

  return (
    <div>
      <Link tw="block hover:(no-underline)" href={`/features/${slug}`} title={`Read: ${title}`}>
        <div tw="shadow-lg min-h-card-lg p-4 pb-8 space-y-4 tablet:(space-y-4) bg-rpd-gray-2 bg-opacity-20">
          <div tw="w-full relative">
            <Image
              src={url}
              alt={altText}
              width={width}
              height={height}
              priority={true}
              sizes="(max-width: 768px) 100vw, 45vw"
            />
          </div>
          <h4 tw="text-2xl tablet-lg:(text-2xl) desktop:(text-2xl-half)">
            {kicker && <em>{kicker}: </em>}
            {title}
          </h4>
          {summaryText && <div tw="text-sm">{summaryText}</div>}
        </div>
      </Link>
    </div>
  )
}

export default Card
